import type { ACCContractType_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { type AttributeChangeProps } from '../../../types';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { Link, SelectField } from '@flos/react-ui';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { infoModalVariantOpcAtom } from '../../../../../recoil/atoms/infoModalVariantOpcAtom';
import { getCoverableInfoSelector } from '../../../../../recoil/selectors/getCoverableInfoSelector';
import { callMeVariantOpcAtom } from '../../../../../recoil/atoms/callMeVariantOpcAtom';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';
import { getOPCCoverableAttributeSelector } from '../../../../../recoil/selectors/getOPCCoverableAttributeSelector';

const contractTypeOptions: Array<{ label: string; value: ACCContractType_Top }> = [
    {
        label: 'Udvidet',
        value: 'Extended'
    },
    {
        label: 'Standard',
        value: 'Standard'
    }
];

const mapContractTypeToLabel = (contractTypeValue: string): string => {
    return contractTypeOptions.find((option) => option.value === contractTypeValue)?.label ?? '';
};

const AdultAccContractTypeChange = ({
    updateCoverableAttribute
}: AttributeChangeProps): React.JSX.Element => {
    const getHippoText = useHippoText();
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const currentOPCAttribute = useRecoilValue(getOPCCoverableAttributeSelector)?.adultAccident
        ?.contractType;
    const setInformationModalVariant = useSetRecoilState(infoModalVariantOpcAtom);
    const setCallMeVariant = useSetRecoilState(callMeVariantOpcAtom);
    const { isAdultAccContractTypeExtended } = useRecoilValue(getCoverableInfoSelector);
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);

    return (
        <>
            <h6>{getHippoText('DSS-COVERABLE-DETAILS-STEP-CONTRACT-TYPE-SUBHEADER')}</h6>
            <SelectField
                label={getHippoText('DSS-OPC-INPUT-LABEL')}
                options={contractTypeOptions}
                placeholder={
                    isAdultAccContractTypeExtended
                        ? mapContractTypeToLabel('Extended')
                        : mapContractTypeToLabel('Standard')
                }
                onChange={(e) => {
                    const selectedIndex = e.target.selectedIndex;
                    const { value } = e.target.options[selectedIndex];
                    if (
                        isAdultAccContractTypeExtended &&
                        (value as ACCContractType_Top) === 'Standard'
                    ) {
                        setCallMeVariant('extendedToStandard');
                        return;
                    }
                    updateCoverableAttribute({
                        contractType: value as ACCContractType_Top
                    });
                    setIsOpcDataFilled(true);
                }}
                disabled={isOpcFetching}
                defaultValue={currentOPCAttribute}
            ></SelectField>
            <div className="u-spacing-inset-bottom-6">
                <Link
                    onClick={() => {
                        setInformationModalVariant('adultAccContractType');
                    }}
                    className="u-color-primary-2-base"
                >
                    {getHippoText('DSS-COVERABLE-DETAILS-STEP-CONTRACT-TYPE-INFO-MODAL')}
                </Link>
            </div>
        </>
    );
};

export { contractTypeOptions, mapContractTypeToLabel };

export default AdultAccContractTypeChange;
